// FILECONTENT_START src/common/components/Inputs/Checkbox/index.ts
import Checkbox from "./Checkbox";
export default Checkbox;
export type { CheckboxProps } from "./Checkbox";

// FILECONTENT_END src/common/components/Inputs/Checkbox/index.ts